import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import { Switch, useHistory, Route, useLocation } from "react-router-dom";
import Split from "react-split-grid";
import { useEditMode } from "../customHooks/useEditMode";
import { SlidersContext } from "../providers/SlidersProvider";
import CloseIcon from "@mui/icons-material/Close";
import "../css/slider.scss";
import PdfTimesheet from "./PdfTimesheet";
import JobsheetView from "./JobsheetView";
import JobDescription from "./JobDescription";
import Timesheet from "./Timesheet";
import Materials from "./Materials";
import Quote from "./Quote";
import Jobsheet from "./Jobsheet";
import Restore from "./Restore";

const defaultRoute = {
  timesheet: "/",
  quote: "/quotes",
  jobsheet: "/jobsheets",
  restore: "/restores",
};

export const SliderContainer = React.memo(({ primaryType }) => {
  const isQuote = primaryType === "quote" ? true : false;

  return (
    <>
      <Switch>
        <Route exact path={`/${primaryType}/pdf`}>
          <PdfTimesheet isQuote={isQuote} />
        </Route>

        <Route exact path={`/${primaryType}/jobsheetView`}>
          <JobsheetView />
        </Route>

        <Route path={`/${primaryType}/jobDescription/:uid`}>
          <JobDescription />
        </Route>

        <Route exact path={`/${primaryType}/materials`}>
          <Materials />
        </Route>

        <Route path={`/timesheet/:uid`}>
          <Timesheet />
        </Route>
        <Route path={`/jobsheet/:uid`}>
          <Jobsheet />
        </Route>
        <Route path={`/quote/:uid`}>
          <Quote />
        </Route>
        <Route path={`/restore/:uid`}>
          <Restore />
        </Route>
      </Switch>
    </>
  );
});

const SliderWrapper = (props) => {
  const gridRef = useRef(null);
  const baseRef = useRef(null);
  // const location = useLocation();
  // const history = useHistory();
  const sideRef = useRef(null);
  const { sliders, sliderId, closeSlider } = useContext(SlidersContext);

  // const [currentPrimary, setCurrentPrimary] = useState(
  //   window.sessionStorage.getItem("currentPrimary")
  // );

  // useEffect(() => {
  //   setCurrentPrimary(window.sessionStorage.getItem("currentPrimary"));
  // }, [window.sessionStorage.getItem("currentPrimary")]);

  // const fullScreenSlider = () => {
  //   gridRef.current.style.gridTemplateColumns = "0fr 10px 1fr";
  // };

  // if sliders are on and primary has been selected
  // const showSlider = sliders && currentPrimary;
  const showSlider = sliders && sliderId;

  return (
    <>
      {showSlider ? (
        <Split
          snapOffset={10}
          dragInterval={2}
          columnMinSize={0}
          render={({ getGridProps, getGutterProps }) => (
            <div ref={gridRef} className="grid" {...getGridProps()}>
              <div onClick={(e) => {}} ref={baseRef} className="content base">
                {props.children[0]}
              </div>
              {/* <h4>This is the left hand side I think</h4> */}

              <div
                className="gutter-col gutter-col-1"
                {...getGutterProps("column", 1)}
              />

              <div ref={sideRef} className="content side">
                <div className="slider-controls">
                  {/* <button onClick={fullScreenSlider}>{"<-"}</button> */}
                  <button className="close" onClick={closeSlider}>
                    <CloseIcon />
                  </button>
                </div>
                {props.children[1]}
              </div>
              {/* <h4>This is the right hand side I think</h4> */}
            </div>
          )}
        />
      ) : (
        props.children[0]
      )}
      {/* <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}

      {/* {props.children[1]}

      {props.children[0]}

      {props.children[1]} */}
    </>
  );
};

export default React.memo(SliderWrapper);
